import type { ReactNode } from 'react';

import { useRouteLoaderData } from '@remix-run/react';
import type { TContainerElement } from '@shared/dream-components';
import { ContainerElement } from '@shared/dream-components';

import type { RootLoaderData } from '~/root';

interface Props {
  node: TContainerElement;
  children: ReactNode | ReactNode[];
}

const Container = ({ node, children }: Props) => {
  const { subscription, isLoggedIn } = useRouteLoaderData('root') as RootLoaderData;

  const isPremiumUser = Boolean(subscription) && subscription.tier === 'premium' && subscription.status !== 'paused';

  const showWhen = node.attrs?.showWhen;

  if (showWhen) {
    const shouldShow =
      showWhen === 'all' ||
      (showWhen === 'all_logged_out' && !isLoggedIn) ||
      (showWhen === 'all_logged_in' && isLoggedIn) ||
      (showWhen === 'paid' && isLoggedIn && isPremiumUser) ||
      (showWhen === 'free' && isLoggedIn && !isPremiumUser);

    if (!shouldShow) {
      return null;
    }
  }

  return <ContainerElement element={node}>{children}</ContainerElement>;
};

export default Container;
